import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({ providedIn: 'root' })
export class SnackbarService {
  _snackBar = inject(MatSnackBar);

  green(message: string, action: string = '') {
    this._snackBar.open(message, action, {
      duration: 3500,
      panelClass: ['snackbar-green'],
      horizontalPosition: 'right',
    });
  }

  blue(message: string, action: string = '') {
    this._snackBar.open(message, action, {
      duration: 3500,
      panelClass: ['snackbar-blue'],
      horizontalPosition: 'right',
    });
  }

  red(message: string, action: string = '') {
    this._snackBar.open(message, action, {
      duration: 6000,
      panelClass: ['snackbar-red'],
      horizontalPosition: 'right',
    });
  }

  orange(message: string, action: string = '') {
    this._snackBar.open(message, action, {
      duration: 3500,
      panelClass: ['snackbar-orange'],
      horizontalPosition: 'right',
    });
  }
}
